export default "__VITE_ASSET__DwFoUCC9__"